import React, { useEffect } from "react";
import { Card, CardHeader, CardBody, Col, Row } from "reactstrap";
import { Badge, Tabs, Input, Modal, Descriptions, Button, Form, Divider } from "antd";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { add_system } from "../../Redux/actions";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UploadList from "./UploadList";
import { error, success, warning } from "../../Controllers/toast";
import { gql, useMutation } from "@apollo/client";
import QrReaderComponent from "./QRCodeCamera";
import TreeListSystem from "./treeListSystem";
import "./style.css"
import findPlantId from "../../Controllers/findPlantId";
import BlockGroupsComponent from "./blockGroupsComponent";

const { TabPane } = Tabs;
// const { confirm } = Modal;

const ChoiceSystem = ({ plant_id }) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  // Redux Start
  const new_system = useSelector((state) => state.add_system);

  const dispatch = useDispatch();
  //   Readux end

  const [listData, setListData] = useState();
  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [counter, setCounter] = useState(0)
  const [blockNameId, setBlockNameId] = useState(0)
  const [serialNumber, setSerialNumber] = useState();
  const [batchNumber, setBatchNumber] = useState();

  const CHECK_GATEWAY = gql`
    mutation CheckGateWayInput(
      $serial_number: String!
      $batch_number: String!
    ) {
      CheckGatewayDevicesStatus(
        serial_number: $serial_number
        batch_number: $batch_number
      ) {
        Gateway_id
        serial_number
        batch_number
        status
      }
    }
  `;
  const [checkGateway] = useMutation(
    CHECK_GATEWAY,
    {
      onCompleted: (data) => {
        if (
          data.CheckGatewayDevicesStatus.serial_number &&
          data.CheckGatewayDevicesStatus.Gateway_id
        ) {
          setListData({ ...data.CheckGatewayDevicesStatus });
          showModal();
        } else {
          error(lang_choiced.pages.add_fact.rules.errorDeviceNotFound);
        }
      },
      onError: (err) => {
        // console.log(err.message);
        error(err.message);
      },
    }
  );

  const GET_ASSIGNED_GATEWAYS = gql`
mutation Mutation($plant_id: Int!, $gatewayDevicesInput: DevicesInput, $block_name_id:Int) {
  AssignGateway(plant_id: $plant_id, gatewayDevicesInput: $gatewayDevicesInput,block_name_id: $block_name_id) {
    Gateway_id
    serial_number
    batch_number
    status
  }
}`
  const [assignGateway, { loading }] = useMutation(GET_ASSIGNED_GATEWAYS, {
    onCompleted: (res) => {
      console.log(res.AssignGateway);
      setTableData(res.AssignGateway)
      success(lang_choiced.pages.add_system.add_devices_successfully)
      setCounter(counter + 1)
    },
    onError: (err) => {
      // console.log(err);
      error(err.message);
    },
  })




  const handleError = (err) => {
    console.error(err);
  };

  const { Search } = Input;

  // console.log(new_system);
  const notify_success = (value) =>
    toast.success(`${value} ${lang_choiced.pages.add_fact.rules.successAddDevice}`);
  // const notify_danger = () => toast.warn("دستگاه با موفقیت حذف شد!");

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = (e) => {
    setVisible(false);
    notify_success(listData.serial_number);
    // console.log(listData)
    // dispatch(add_system(listData));
    assignGateway({
      variables: {
        plant_id: parseInt(findPlantId()),
        gatewayDevicesInput: {
          devices: [{ serial_number: listData.serial_number, batch_number: listData.batch_number }]
        },
        block_name_id:blockNameId
      }
    })
    setCounter(1)
    // props.data(listData)
  };

  const handleCancel = (e) => {
    setVisible(false);
  };
  const Check = async ({ serial_number, batch_number }) => {
    // console.log(serial_number, batch_number)
    var check = new_system.findIndex(
      (system) => system.serial_number === serial_number
    );
    if (check >= 0) {
      error(lang_choiced.pages.add_fact.rules.errorDeviceRepeatedly);
    } else {
      checkGateway({ variables: { serial_number, batch_number } });
    }
  };

  const checkStatus = (status) => {
    switch (status) {
      case "active":
        return {
          bool: true,
          component: <Badge status="error" text={lang_choiced.pages.add_fact.badges.active} />,
        };
      case "deactive":
        return {
          bool: false,
          component: <Badge status="success" text={lang_choiced.pages.add_fact.badges.deactive} />,
        };
      default:
        return true;
    }
  };

  // console.log(counter);


  return (
    <div>
      {/* <ToastContainer rtl={true} /> */}
      <Modal
        title={lang_choiced.pages.add_system.title}
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        okButtonProps={{ disabled: checkStatus(listData?.status).bool }}
        okText={lang_choiced.pages.add_system.Modal.btnAdd}
        cancelText={lang_choiced.pages.add_system.Modal.btnCancel}
      >
        <Descriptions title={lang_choiced.pages.add_system.Modal.unit_info} layout="vertical" bordered>
          <Descriptions.Item label={lang_choiced.pages.add_system.Modal.serial_number} span={3}>
            {visible === true ? listData.serial_number : ""}
          </Descriptions.Item>
          <Descriptions.Item label={lang_choiced.pages.add_system.Modal.unit_status} span={3}>
            {checkStatus(listData?.status).component}
          </Descriptions.Item>
          <Descriptions.Item label={"بلوک دستگاه"} span={3}>
            <BlockGroupsComponent setBlockNameId={id => setBlockNameId(id)} plantId={plant_id}/>
          </Descriptions.Item>
        </Descriptions>
      </Modal>
      <Card>
        <CardHeader>{lang_choiced.pages.add_system.title}</CardHeader>
        <CardBody>
          <Tabs defaultActiveKey="1" type="card" size={"large"}>
            <TabPane tab={lang_choiced.pages.add_system.tabs.enterSerial.title} key="1">
              <Form
                layout="vertical"
                onFinish={({ serial_number, batch_number }) => {
                  if (serial_number !== "" && batch_number !== "" ) {
                    Check({ serial_number, batch_number });
                  } else {
                    warning(lang_choiced.pages.add_system.Modal.warnFillInput);
                  }
                }}
              >
                <Form.Item name="serial_number" label={lang_choiced.pages.add_system.tabs.enterSerial.serialNumberText}>
                  <Input onChange={e => setSerialNumber(e.target.value)} />
                </Form.Item>
                <Form.Item name="batch_number" label={lang_choiced.pages.add_system.tabs.enterSerial.batchNumberText}>
                  <Input onChange={e => setBatchNumber(e.target.value)} />
                </Form.Item>
                <Form.Item>
                  <Button disabled={(!serialNumber || !batchNumber) ? true : false} htmlType="submit">{lang_choiced.pages.add_system.tabs.enterSerial.btnReview}</Button>
                </Form.Item>
              </Form>
            </TabPane>
            <TabPane tab={lang_choiced.pages.add_system.tabs.scanSerial.title} key="2" className="qr-reader-section">
              <QrReaderComponent
                handleError={handleError}
                Check={(data) => Check(data)}

              />
            </TabPane>
            <TabPane disabled tab={lang_choiced.pages.add_system.tabs.fileUpload.title} key="3">
              <UploadList
                setCounter={(c) => setCounter(counter + c)}
                tableData={tableData}
                assignGateway={e => assignGateway(e)} />
            </TabPane>
          </Tabs>
        </CardBody>
      </Card>
      <Card>
        <CardHeader>{lang_choiced.pages.add_system.devices_list.title}</CardHeader>
        <CardBody>
          {/* <ListSystem plant_id={plant_id}/> */}

          <TreeListSystem
            plant_id={plant_id}

            counter={counter}
            setCounter={e => setCounter(e)}
          />

        </CardBody>
      </Card>
    </div>
  );
};

export default ChoiceSystem;
